// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedSubscriptionType {
  Corporate: {"enum_constant":"Corporate"};
  Coupon: {"enum_constant":"Coupon"};
  Free: {"enum_constant":"Free"};
  None: {"enum_constant":"None"};
  Periodic: {"enum_constant":"Periodic"};
  Trial: {"enum_constant":"Trial"};
}

export type SubscriptionTypeId = keyof IParsedSubscriptionType;
export type SubscriptionTypeData = IParsedSubscriptionType[SubscriptionTypeId];
const data: SubscriptionTypeData[] = [{"enum_constant":"Corporate"},{"enum_constant":"Coupon"},{"enum_constant":"Free"},{"enum_constant":"None"},{"enum_constant":"Periodic"},{"enum_constant":"Trial"}];
export default data;
